import styled from "styled-components";

export const Card = styled.div`
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid var(--line-primary-n-200, #E7E7F0);
  background: var(--background-white-n-0, #FFF);
`;

export const Header = styled.div`
  display: flex;
  padding: 16px 16px 12px 16px;
  justify-content: space-between;
  align-items: center;
  background: rgba(249, 246, 255, 0.6);
`;

export const Title = styled.div`
  color: var(--Neutral-N500, #36354c);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const Body = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 16px;
  gap: 12px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #f7f7fa;
  border-radius: 50%;
  flex-shrink: 0;
`;

export const AddressContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const AddressText = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.1px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ChangeButton = styled.button`
  background: none;
  border: none;
  color: var(--button-hyperlink-b-300, #1b73e8);
  text-align: right;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;
